import { useLayoutEffect } from "react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import posthog from "posthog-js"
import { useAppSelector } from "@/reducers/hooks"
import { selectUiLanguage } from "@/reducers/settingsSlice"
import i18n from "./i18n"
import { htmlLangFor, resolveI18nLanguage } from "./language"

// The one place that maps the flag and the saved choice to the i18next
// language. A layout effect, so a Polish user gets Polish before the first
// paint (the choice is persisted, so it is known before XMPP connects).
const UiLanguageSync = () => {
  // The hook stays undefined until PostHog's flag request answers. Until
  // then, the flags saved from the last session decide; without this a
  // Polish user would get an English first paint on every reload.
  const flagEnabled =
    useFeatureFlagEnabled("ui-language") ??
    posthog.isFeatureEnabled("ui-language", { send_event: false })
  const uiLanguage = useAppSelector(selectUiLanguage)
  const language = resolveI18nLanguage(flagEnabled, uiLanguage)

  useLayoutEffect(() => {
    if (i18n.language !== language) i18n.changeLanguage(language)
    document.documentElement.lang = htmlLangFor(language)
  }, [language])

  return null
}

export default UiLanguageSync
